import { render } from "./avatar-item.vue?vue&type=template&id=9d39fe38&ts=true"
import script from "./avatar-item.vue?vue&type=script&lang=ts"
export * from "./avatar-item.vue?vue&type=script&lang=ts"

import exportComponent from "/azp/agent/_work/1/s/frontend-financier/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__